import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { TooltipIcon } from '@anwb/tooltip';
import Typography from '@anwb/typography';
import { pickToken } from './helper';
/**
 * This function makes it easier to assign state styles to color and size checkbox. The deisgns of these checkboxes will be updated in the near future
 */
export const baseStateStyles = ({ hover, checked, disabled, error, focus, }) => css `
	// Hover
	${RadioCheckboxLabel}:hover ${RadioCheckboxInputContainer}:not([disabled]):not(:checked) + & {
		${hover};
	}

	// Checked
	${RadioCheckboxInputContainer}:checked + & {
		${checked}
	}

	// Disabled
	${RadioCheckboxInputContainer}[disabled] + & {
		${disabled}
	}

	// Error
	${RadioCheckboxInputContainer}[aria-invalid] + & {
		${error}
	}

	// Focus
	${RadioCheckboxInputContainer}:focus + & {
		${focus}
	}

	// Focus + Checked
	${RadioCheckboxInputContainer}:focus:checked + & {
		${checked}
		${focus}
	}
`;
/**
 * This function makes it a lot easier to assign state styles for the checkbox/radio replacement
 * components
 */
export const stateStyles = ({ default: { defaultHover, defaultChecked, defaultHoverChecked }, error: { errorBase, errorHover, errorChecked }, disabled: { disabledBase, disabledChecked }, focus, }) => css `
	// default hover
	${RadioCheckboxLabel}:hover ${RadioCheckboxInputContainer}:not([disabled]):not(:checked):not([aria-invalid]) + & {
		${defaultHover}
	}

	// default checked
	${RadioCheckboxInputContainer}:not([aria-invalid]):checked + & {
		${defaultChecked}
	}

	// default hover checked
	${RadioCheckboxLabel}:hover ${RadioCheckboxInputContainer}:not([disabled]):not([aria-invalid]):checked + & {
		${defaultHoverChecked}
	}

	// error
	${RadioCheckboxInputContainer}[aria-invalid] + & {
		${errorBase}
	}

	// error hover
	${RadioCheckboxLabel}:hover ${RadioCheckboxInputContainer}:not([disabled])[aria-invalid] + & {
		${errorHover}
	}

	// error checked
	${RadioCheckboxInputContainer}[aria-invalid]:checked + & {
		${errorChecked}
	}

	// disabled
	${RadioCheckboxInputContainer}[disabled]:not(:checked) + & {
		${disabledBase}
	}

	// disabled checked
	${RadioCheckboxInputContainer}[disabled]:checked + & {
		${disabledChecked}
	}

	// focus
	${RadioCheckboxLabel}:focus-visible &,
	${RadioCheckboxInputContainer}:focus-visible + & {
		${focus}
	}
`;
export const overrideCoreUIStyles = () => css `
	&&& {
		display: flex;
		padding-left: 0;
		box-sizing: border-box;

		&:before {
			width: 0;
			height: 0;
			border: none;
			border-radius: unset;
			background: none;
			position: unset;
			margin-top: 0;
		}
	}
`;
/**
 * Input
 */
export const radioCheckboxInputContainerStyles = ({ theme }) => css `
	width: ${pxToRem(theme.borderWidth[2])};
	height: ${pxToRem(theme.borderWidth[2])};
	padding: 0;
	margin: -1px;
	overflow: hidden;
	position: absolute;
	clip: rect(0, 0, 0, 0);
`;
export const RadioCheckboxInputContainer = styled.input `
	${radioCheckboxInputContainerStyles}
`;
/**
 * Container
 */
export const radioCheckboxLabelStyles = ({ theme, $disabled, $colorContext, }) => css `
	display: inline-flex;
	gap: ${pxToRem(theme.spacing['200'])};
	align-items: flex-start;
	color: ${pickToken({
    'on-light': theme.colors.base.textBody,
    'on-medium': theme.colors.base.textBody,
    'on-dark': theme.colors.blanc.textInverse,
}, $colorContext)};

	${TooltipIcon} {
		margin-left: 0;
	}

	${!$disabled &&
    css `
		cursor: pointer;
	`};

	${$disabled &&
    css `
		color: ${pickToken({
        'on-light': theme.colors.base.textBodyInactive,
        'on-medium': theme.colors.medium.textInactiveOnMedium,
        'on-dark': theme.colors.medium.textInactive,
    }, $colorContext)};
	`}
`;
export const RadioCheckboxLabel = styled(Typography).attrs({
    tagName: 'label',
    variant: 'body-text',
}) `
	${radioCheckboxLabelStyles}
`;
//# sourceMappingURL=common.styled.js.map